export const soundData = 
    {
        techno: 
            [
                {name: 'kick', file:'techno/kick.wav', image:'kick.webp'}, 
                {name: 'clap', file:'techno/clap.wav', image:'clap.png'},
                {name: 'hihat', file:'techno/hihat.wav', image:'hihat.webp'},
                {name:'rimshot', file:'techno/rimshot.wav', image:'fx.webp'},
                {name: 'vocal', file:'techno/vocal.wav', image:'voice.webp'},
                {name: 'chord', file:'techno/chord.wav', image:'synth.webp'},
                {name: 'fx1', file:'techno/fx1.wav', image:'fx.webp'},
                {name: 'fx2', file:'techno/fx2.wav', image:'fx.webp'}  
            ],
        house: 
            [
                {name: 'kick', file:'house/kick.wav', image:'kick.webp'},
                {name: 'clap', file:'house/clap.wav', image:'clap.png'},
                {name: 'hihat', file:'house/hihat.wav', image:'hihat.webp'},
                {name:'snare', file:'house/snare.wav', image:'snare.webp'},
                {name:'perc', file:'house/perc.wav', image:'tom.webp'},
                {name:'fx', file:'house/fx.wav', image:'fx.webp'},
                {name:'chord1', file:'house/chord1.wav', image:'synth.webp'},
                {name:'chord2', file:'house/chord2.wav', image:'synth.webp'}
            ],
        glitch: 
            [
                {name: 'bassdrum', file:'glitch/bassdrum.wav', image:'kick.webp'},
                {name: 'clap', file:'glitch/clap.wav', image:'clap.png'},
                {name: 'closedhat', file:'glitch/closedhat.wav', image:'hihat.webp'},
                {name:'openhat', file:'glitch/openhat.wav', image:'hihat.webp'},
                {name:'cuica', file:'glitch/cuica.wav', image:'fx.webp'},
                {name:'guiro', file:'glitch/guiro.wav', image:'fx.webp'}, 
                {name:'whistle', file:'glitch/whistle.wav', image:'fx.webp'}, 
                {name:'cowbell', file:'glitch/cowbell.wav', image:'fx.webp'}, 
            ],
        classic: 
            [
                {name: 'kick', file:'classic/kick.wav', image:'kick.webp'},
                {name: 'snare', file:'classic/snare.wav', image:'snare.webp'},
                {name: 'hihat', file:'classic/hihat.wav', image:'hihat.webp'},
                {name:'crash', file:'classic/crash.wav', image:'cymbal.webp'},
                {name:'splash', file:'classic/splash.wav', image:'cymbal.webp'},
                {name:'floortom', file:'classic/floortom.wav', image:'tom.webp'}, 
                {name:'midtom', file:'classic/midtom.wav', image:'tom.webp'}, 
                {name:'hightom', file:'classic/hightom.wav', image:'tom.webp'}, 
            ],
        hiphop: 
            [
                {name: 'kick', file:'hiphop/kick.wav', image:'kick.webp'},
                {name: 'snare', file:'hiphop/snare.wav', image:'snare.webp'},
                {name: 'hihat', file:'hiphop/hihat.wav', image:'hihat.webp'},
                {name:'claves', file:'hiphop/claves.mp3', image:'claves.png'},
                {name:'gun', file:'hiphop/gun.mp3', image:'fx.webp'},
                {name:'voice1', file:'hiphop/voice1.mp3', image:'voice.webp'}, 
                {name:'voice2', file:'hiphop/voice2.mp3', image:'voice.webp'}, 
                {name:'voice3', file:'hiphop/voice3.mp3', image:'voice.webp'}, 
            ],
        chiptune: 
            [
                {name: 'kick', file:'chiptune/kick.wav', image:'kick.webp'},
                {name: 'snare', file:'chiptune/snare.wav', image:'snare.webp'},
                {name: 'closed', file:'chiptune/closedhat.wav', image:'hihat.webp'},
                {name:'openhat', file:'chiptune/openhat.wav', image:'hihat.webp'},
                {name:'perc1', file:'chiptune/perc1.wav', image:'tom.webp'},
                {name:'perc2', file:'chiptune/perc2.wav', image:'tom.webp'}, 
                {name:'perc3', file:'chiptune/perc3.wav', image:'tom.webp'},
                {name:'arp', file:'chiptune/arp.wav', image:'fx.webp'}, 
            ],      
    }